import React from 'react';

import { IntlShape } from 'react-intl';

import { ServiceMode } from 'generated/graphql-gateway';

interface IGetOrderConfirmationHeader {
  userName: string;
  formatMessage: IntlShape['formatMessage'];
}

interface IGetOrderConfirmationInstructions {
  userName: string;
  serviceMode: ServiceMode;
  formatMessage: IntlShape['formatMessage'];
  isMobileOrderForDriveThruLaneEnabled: boolean;
}

export const getOrderConfirmationHeader = ({
  userName,
  formatMessage,
}: IGetOrderConfirmationHeader): string => {
  return formatMessage({ id: 'orderIsBeingMadeYourWay' }, { userName });
};

export const getOrderConfirmationInstructions = ({
  userName,
  serviceMode,
  formatMessage,
  isMobileOrderForDriveThruLaneEnabled,
}: IGetOrderConfirmationInstructions): string | React.ReactNode | null => {
  let instructions;

  switch (serviceMode) {
    case ServiceMode.EAT_IN:
      instructions = 'orderConfirmationInstructionsConfirmed';
      break;
    case ServiceMode.TAKEOUT:
      instructions = 'orderConfirmationInstructionsTakeOut';
      break;
    case ServiceMode.DELIVERY:
      instructions = 'orderConfirmationInstructionsDelivery';
      break;
    case ServiceMode.DRIVE_THRU:
      instructions = isMobileOrderForDriveThruLaneEnabled
        ? 'orderConfirmationInstructionsMobileDriveThru'
        : 'orderConfirmationInstructionsDriveThru';
      break;
    case ServiceMode.MOBILE_ORDER_DRIVE_THRU:
      instructions = 'orderConfirmationInstructionsMobileDriveThru';
      break;
    default:
      instructions = '';
  }

  return instructions ? formatMessage({ id: instructions }, { userName } as any) : null;
};
